import { render, staticRenderFns } from "./FaultMaintenanceRecord.vue?vue&type=template&id=373cf53d&scoped=true"
import script from "./FaultMaintenanceRecord.vue?vue&type=script&lang=js"
export * from "./FaultMaintenanceRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373cf53d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('373cf53d')) {
      api.createRecord('373cf53d', component.options)
    } else {
      api.reload('373cf53d', component.options)
    }
    module.hot.accept("./FaultMaintenanceRecord.vue?vue&type=template&id=373cf53d&scoped=true", function () {
      api.rerender('373cf53d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Operation/FaultMaintenanceRecord/FaultMaintenanceRecord.vue"
export default component.exports